import themeStyles from '../styling/backgroundTheme.module.css';

/**
 * @param {string|undefined} backgroundColorStr; as given from contentful
 */
export default function getColor(backgroundColorStr) {
  if (!backgroundColorStr) {
    return '';
  }

  return (
    themeStyles[
      `theme${backgroundColorStr.split(' (#')[0].replaceAll(' ', '')}`
    ] || ''
  );
}
